import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import { AssessmentDetails } from "Assessments";
import { LeDetails } from "LearningEngagement";
export default store => {
  return {
    path: ":flow_id",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "unit-planner" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return withDynamicUrlValidation({
            component,
            urlValidationType: "number",
          });
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [AssessmentDetails(store), LeDetails(store)],
  };
};
